// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__b1oSy","footer":"ModalInfo_footer__2JvLv"};